class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.megaMenuContent = this.mainDetailsToggle.querySelector('.mega-menu__content');
  }

  onToggle() {
    if (!this.header) return;

    const isOpen = this.mainDetailsToggle.hasAttribute('open');
    this.header.preventHide = isOpen;

    if (!isOpen && this.megaMenuContent) {
      if (!document.querySelector('.header__search details[open]')) {
        document.body.style.overflow = '';
      }
      this.megaMenuContent.style.animation = 'menuHide 150ms ease-in forwards';

      const subcategoryButtons = this.megaMenuContent.querySelectorAll('.category-subcategory-button');
      subcategoryButtons.forEach((button) => {
        button.classList.remove('animate');
      });
    }

    const headerBottomPosition = document.documentElement.style.getPropertyValue('--header-bottom-position-desktop');
    if (headerBottomPosition === '') {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }

    if (this.megaMenuContent && isOpen) {
      this.megaMenuContent.style.animation = 'menuShow 150ms ease-out forwards';
      document.body.style.overflow = 'hidden';

      const subcategoryButtons = this.megaMenuContent.querySelectorAll('.category-subcategory-button');
      subcategoryButtons.forEach((button, index) => {
        button.classList.remove('animate');
        setTimeout(() => {
          button.classList.add('animate');
        }, index * 12);
      });
    }
  }
}

customElements.define('header-menu', HeaderMenu);
